import { render, staticRenderFns } from "./Cidades.vue?vue&type=template&id=fe9a8da0&scoped=true&"
import script from "./Cidades.ts?vue&type=script&lang=ts&"
export * from "./Cidades.ts?vue&type=script&lang=ts&"
import style0 from "./cidades.scss?vue&type=style&index=0&id=fe9a8da0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9a8da0",
  null
  
)

export default component.exports